import mustache from 'mustache';
import { LabelTemplate } from 'types/inventory';

const toAscii = (str: string): string =>
  str
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '') // Remove diacritics
    .replace(/[^\x20-\x7F]/g, ''); // Remove non-ASCII characters

const trimLambda = (text: string, render: (text: string) => string): string => {
  // Split the rendered content into parts
  const parts = text.split('|');
  if (parts.length !== 2) {
    return render(text);
  }

  // First part is the content, second part is the length
  const content = parts[0];
  const length = parseInt(parts[1], 10);
  return render(content).slice(0, length);
};

export const generateZpl = (
  labelTemplate: LabelTemplate,
  data: { [key: string]: any }
): string => {
  data.trim = trimLambda;
  return toAscii(mustache.render(labelTemplate.zpl, data));
};
